export default __webpack_public_path__ + "static/media/tutorialWeb-3.6.872a035e.png";